import React, { useReducer, useState, useContext } from 'react';
import api from './ApiCall';
import { TRAINER_LIST, TRAINER_DETAILS, TrainerContext, CommonContext } from './../constant/ActionTypes';
import { trainerReducer } from './../reducer/trainerReducer';
import Loader from './../../common/Loader/Loader';

const initialState = {
    trainerList: [],
    trainerDetails: {}
}

const TrainerProvider = (props) => {
    const commonContext = useContext(CommonContext);

    const [trainerState, dispatch] = useReducer(trainerReducer, initialState);

    const [showLoader, setShowLoader] = useState(false);

    // get trainer list
    const getTrainerList = (page=null, offset=null) => {
        let pageLink = '';
        if (page) {
            pageLink = `?page=${page}&itemSize=${offset}`;
        }

        api({ contentType: true, auth: true }).get(`TrainerService/getAll/${pageLink}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: TRAINER_LIST,
                    payload: response.data.result && response.data.result.content ? response.data.result.content : response.data.result
                });
                commonContext.updatePagination(response.data.result);
                if (
                    !(response.data.result && response.data.result.length > 0) ||
                    !(response.data.result && response.data.result.content && response.data.result.content.length > 0)
                ) {
                    commonContext.updateLoaderMsg('No data found')
                }
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const clearTrainerList = () => {
        dispatch({
            type: TRAINER_LIST,
            payload: []
        });
    }

    // get trainer detail
    const getTrainerDetails = (trainer_id) => {
        api({ contentType: true, auth: true }).get(`TrainerService/getDetails/${trainer_id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: TRAINER_DETAILS,
                    payload: response.data.result
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    // add trainer
    const addTrainer = (trainerdetail) => {
        setShowLoader(true);
		let data = {
			firstname: trainerdetail.firstname,
            lastname: trainerdetail.lastname,
            phone: trainerdetail.phone,
            email: trainerdetail.email,
            country: trainerdetail.country,
            city: trainerdetail.city
        }
        api({ contentType: true, auth: true }).post('TrainerService/add', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getTrainerList(1,25);
                commonContext.handleSnackbar(true, 'success', response.data.message);
            }
            if(response.data.status.toLowerCase() === 'failure') {
                getTrainerList(1,25);
                commonContext.handleSnackbar(true, 'error', response.data.message);
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }
    
    // update trainer list
    const updateTrainerDetails = (trainerdetail,trainer_id) => {
        setShowLoader(true);
        let data = {
            id: trainer_id,
            firstname: trainerdetail.firstname,
            lastname: trainerdetail.lastname,
            email: trainerdetail.email,
            phone: trainerdetail.phone,
            country: trainerdetail.country,
            city: trainerdetail.city
        }
        api({ contentType: true, auth: true }).patch('TrainerService/update', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getTrainerList(1,25);
                commonContext.handleSnackbar(true, 'success', response.data.message);
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }

    // delete trainer
    const deleteTrainer = (trainer_id) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).patch(`TrainerService/delete/${trainer_id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
				getTrainerList(1,25);
                commonContext.handleSnackbar(true, 'success', response.data.message);
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }

    const setTableFilters = (objData) => {
        dispatch({
            type: SET_TABLE_FILTERS,
            payload: objData
        });
    }

    return (
        <TrainerContext.Provider
            value={{
                ...trainerState,
                getTrainerList: getTrainerList,
                getTrainerDetails: getTrainerDetails,
                updateTrainerDetails: updateTrainerDetails,
                deleteTrainer: deleteTrainer,
                addTrainer: addTrainer,
                setTableFilters: setTableFilters,
                clearTrainerList: clearTrainerList
            }}
        >
            {props.children}
            {showLoader && <Loader onlyLoading />}
        </TrainerContext.Provider>
    );
}

export default TrainerProvider;



// WEBPACK FOOTER //
// ./contexts/provider/TrainerContext.js